"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const slLocaleData = require("i18next-icu/locale-data/sl");
exports.default = slLocaleData;
//# sourceMappingURL=sl.js.map